const defaultPortalUrl =
  process.env.NODE_ENV === "development" && typeof window !== "undefined"
    ? window.location.origin
    : "https://portal.ipdi.co.in";

export const portalBaseUrl = (
  process.env.REACT_APP_PORTAL_URL || ""
).replace(/\/$/, "");

export function portalLink(path) {
  return `${portalBaseUrl}${path}`;
}


// const defaultPortalUrl =
//   process.env.NODE_ENV === "development"
//     ? window.location.origin
//     : "http://magenta-opossum-906971.hostingersite.com/portal";

// export const portalBaseUrl = (
//   process.env.REACT_APP_PORTAL_URL || defaultPortalUrl
// ).replace(/\/$/, "");

// export function portalLink(path) {
//   return `${portalBaseUrl}${path}`;
// }
